import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-imports', storeModule.createStoreModule('customers-imports'))
